import TabToggle from 'components/commons/tab-toogle'
import { Checkbox, InlineError, Input } from 'avo-ui'

export const GeneralData = ({ beautyProfileDetail, onChangeForm, errorForm }) => {
    return (
        <TabToggle
            title={'General Info'}
            content={
                <div className={'flex flex-col w-1/2 space-y-5'}>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Title Beauty Profile</div>
                        <Input
                            className={'flex-1'}
                            name={'name'}
                            placeholder={'Masukkan title beauty profile'}
                            value={beautyProfileDetail?.name}
                            onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.name} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <Checkbox
                            label={'Allow Multiple Select Beauty Profile'}
                            name={'is_allow_multiple'}
                            checked={!!beautyProfileDetail?.is_allow_multiple}
                            value={beautyProfileDetail?.is_allow_multiple}
                            onChange={(item) => onChangeForm({ [item?.name]: item?.checked })}
                        />
                        <InlineError className='mt-2' message={errorForm?.is_allow_multiple} />
                    </div>
                </div>
            }
        />
    )
}
